import React, { useEffect } from 'react'
import styled from 'styled-components'
import { MenuItem, Select, styled as MuiStyled } from '../atom'

const Wrapper = styled.div`
  width: 100%;
  max-width: 260px;
`

const CustomSelect = MuiStyled(Select)({
  width: '100%',
  minWidth: '180px',
  height: '32px',
  color: '#333333',
  fontFamily: 'SUIT',
  fontSize: '16px',
  fontWeight: '500',
  '& .MuiSelect-icon': {
    color: '#808080',
    fontSize: '24px',
  },
  '& .MuiSelect-select': {
    padding: '4px 28px 4px 0',
  },
})

const selectStyle = {
  background: 'transparent',
  boxShadow: 'none',
  border: 0,
}

interface IList {
  value: string
  label: string
}

interface Props {
  title: string
  list?: IList[]
  value?: any
  index: number
  setData: any
  data: any
  selectedValue?: any
  setSelectedValue?: any
}

const PatternSelection = (props: Props) => {
  const { title, list, index, setData, data, selectedValue, setSelectedValue } =
    props
  const patternId = data?.patternList?.[index]?.patternId || ''

  useEffect(() => {
    setSelectedValue?.(patternId)
  }, [patternId, setSelectedValue])

  const handleSelectChange = (e: any) => {
    const selectedVal = e.target.value as string
    setSelectedValue?.(selectedVal)

    setData((prevData: any) => {
      const patternList =
        prevData?.patternList && prevData.patternList.length > 0
          ? prevData.patternList
          : [
              {
                patternId: '',
                months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
              },
            ]
      const newData = patternList.map((item: any, idx: number) => {
        if (idx === index) {
          return {
            ...item,
            patternId: selectedVal,
            months:
              item.months && item.months.length > 0
                ? item.months
                : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
          }
        }
        return item
      })

      return {
        ...prevData,
        patternList: newData,
      }
    })
  }

  return (
    <Wrapper>
      <CustomSelect
        value={selectedValue || ''}
        onChange={handleSelectChange}
        displayEmpty
        variant="standard"
        sx={selectStyle}
      >
        <MenuItem disabled value="" style={{ display: 'none' }}>
          {title}
        </MenuItem>
        {list &&
          list?.map((v) => (
            <MenuItem key={v.value} value={v.value}>
              {v.label}
            </MenuItem>
          ))}
      </CustomSelect>
    </Wrapper>
  )
}

export default PatternSelection
